import React from "react";
import PropTypes from "prop-types";
import { LanguageToggle } from "@sunwing/wvi-components";
import { navigate } from "gatsby";
import { setLanguageCookie } from "../../utils";

const defaultLabels = {
	selectLanguage: "Language preference",
};

const LanguageToggleConnector = ({
	locale,
	classNames,
	altLangPages,
	variant,
	labels: providedLabels,
}) => (
	<LanguageToggle
		locale={locale}
		classNames={classNames}
		altLangPages={altLangPages}
		renderLanguageSwitcher={(id, path, lang, className, label) => (
			<button
				key={id}
				data-id={id}
				type="button"
				data-lang={lang.toLowerCase()}
				onClick={() => {
					setLanguageCookie(lang);
					navigate(path);
				}}
				className={className}>
				{label}
			</button>
		)}
		navigationSwitcher={(path, language) => {
			setLanguageCookie(language);
			navigate(path);
		}}
		variant={variant}
		labels={{ ...defaultLabels, ...providedLabels }}
	/>
);

LanguageToggleConnector.propTypes = {
	locale: PropTypes.string,
	classNames: PropTypes.shape({
		container: PropTypes.string,
		currentLanguage: PropTypes.string,
		altLanguage: PropTypes.string,
	}),
	altLangPages: PropTypes.arrayOf(
		PropTypes.shape({
			id: PropTypes.string.isRequired,
			path: PropTypes.string.isRequired,
			lang: PropTypes.string.isRequired,
		})
	).isRequired,
	variant: PropTypes.oneOf(["drop-down", "toggle"]),
	labels: PropTypes.shape({
		selectLanguage: PropTypes.string,
	}),
};

LanguageToggleConnector.defaultProps = {
	classNames: undefined,
	locale: "en-CA",
	variant: "toggle",
	labels: defaultLabels,
};

export { LanguageToggleConnector };
